var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountOpeningQrcode1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 150,
    viewBox: "0 0 144 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3052_13818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.135 14.396H38.9932V17.5378H42.135V14.396Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4241 14.396H45.2822V17.5378H48.4241V14.396Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5613 14.396H48.4194V17.5378H51.5613V14.396Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7063 14.396H51.5645V17.5378H54.7063V14.396Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5457 14.396H70.4038V17.5378H73.5457V14.396Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6887 14.396H73.5469V17.5378H76.6887V14.396Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9622 14.396H79.8203V17.5378H82.9622V14.396Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2459 14.396H86.104V17.5378H89.2459V14.396Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3831 14.396H89.2412V17.5378H92.3831V14.396Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5256 14.396H92.3838V17.5378H95.5256V14.396Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6584 14.396H95.5166V17.5378H98.6584V14.396Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.135 17.5386H38.9932V20.6804H42.135V17.5386Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2815 17.5381H42.1396V20.6799H45.2815V17.5381Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5613 17.5386H48.4194V20.6804H51.5613V17.5386Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9763 17.5381H57.8345V20.6799H60.9763V17.5381Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1204 17.5386H60.9785V20.6804H64.1204V17.5386Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8191 17.5386H76.6772V20.6804H79.8191V17.5386Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9622 17.5396H79.8203V20.6814H82.9622V17.5396Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0994 17.5381H82.9575V20.6799H86.0994V17.5381Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6584 17.5386H95.5166V20.6804H98.6584V17.5386Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.135 20.6802H38.9932V23.822H42.135V20.6802Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2815 20.6807H42.1396V23.8225H45.2815V20.6807Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4241 20.6797H45.2822V23.8215H48.4241V20.6797Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5613 20.6802H48.4194V23.822H51.5613V20.6802Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7063 20.6802H51.5645V23.822H54.7063V20.6802Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9763 20.6802H57.8345V23.822H60.9763V20.6802Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8191 20.6802H76.6772V23.822H79.8191V20.6802Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9622 20.6802H79.8203V23.822H82.9622V20.6802Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3831 20.6802H89.2412V23.822H92.3831V20.6802Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5256 20.6802H92.3838V23.822H95.5256V20.6802Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6584 20.6807H95.5166V23.8225H98.6584V20.6807Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.793 20.6797H98.6514V23.8215H101.793V20.6797Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.936 20.6807H101.794V23.8225H104.936V20.6807Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2815 23.8091H42.1396V26.9509H45.2815V23.8091Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4241 23.8091H45.2822V26.9509H48.4241V23.8091Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7063 23.8091H51.5645V26.9509H54.7063V23.8091Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9763 23.8096H57.8345V26.9514H60.9763V23.8096Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2654 23.8096H64.1235V26.9514H67.2654V23.8096Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4045 23.8091H67.2627V26.9509H70.4045V23.8091Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6887 23.8091H73.5469V26.9509H76.6887V23.8091Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8191 23.8091H76.6772V26.9509H79.8191V23.8091Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9622 23.8091H79.8203V26.9509H82.9622V23.8091Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5256 23.8091H92.3838V26.9509H95.5256V23.8091Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.936 23.8091H101.794V26.9509H104.936V23.8091Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.135 26.9507H38.9932V30.0925H42.135V26.9507Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2815 26.9507H42.1396V30.0925H45.2815V26.9507Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5613 26.9507H48.4194V30.0925H51.5613V26.9507Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7063 26.9502H51.5645V30.092H54.7063V26.9502Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8547 26.9507H54.7129V30.0925H57.8547V26.9507Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2654 26.9512H64.1235V30.093H67.2654V26.9512Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4045 26.9512H67.2627V30.093H70.4045V26.9512Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5457 26.9502H70.4038V30.092H73.5457V26.9502Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6887 26.9502H73.5469V30.092H76.6887V26.9502Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6584 26.9512H95.5166V30.093H98.6584V26.9512Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.936 26.9507H101.794V30.0925H104.936V26.9507Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2815 30.0928H42.1396V33.2346H45.2815V30.0928Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4241 30.0928H45.2822V33.2346H48.4241V30.0928Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7063 30.0928H51.5645V33.2346H54.7063V30.0928Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8547 30.0933H54.7129V33.2351H57.8547V30.0933Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9763 30.0933H57.8345V33.2351H60.9763V30.0933Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1204 30.0933H60.9785V33.2351H64.1204V30.0933Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2654 30.0933H64.1235V33.2351H67.2654V30.0933Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4055 30.0933H67.2637V33.2351H70.4055V30.0933Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5457 30.0928H70.4038V33.2346H73.5457V30.0928Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9622 30.0928H79.8203V33.2346H82.9622V30.0928Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2459 30.0928H86.104V33.2346H89.2459V30.0928Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6584 30.0923H95.5166V33.2341H98.6584V30.0923Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.936 30.0928H101.794V33.2346H104.936V30.0928Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.135 33.2354H38.9932V36.3772H42.135V33.2354Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4221 33.2349H45.2803V36.3767H48.4221V33.2349Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7063 33.2349H51.5645V36.3767H54.7063V33.2349Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9763 33.2354H57.8345V36.3772H60.9763V33.2354Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2654 33.2349H64.1235V36.3767H67.2654V33.2349Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5457 33.2354H70.4038V36.3772H73.5457V33.2354Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8191 33.2354H76.6772V36.3772H79.8191V33.2354Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0994 33.2358H82.9575V36.3777H86.0994V33.2358Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3831 33.2349H89.2412V36.3767H92.3831V33.2349Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6584 33.2358H95.5166V36.3777H98.6584V33.2358Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.936 33.2358H101.794V36.3777H104.936V33.2358Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2815 36.3774H42.1396V39.5193H45.2815V36.3774Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2659 36.3774H64.124V39.5193H67.2659V36.3774Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6887 36.3774H73.5469V39.5193H76.6887V36.3774Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9622 36.3774H79.8203V39.5193H82.9622V36.3774Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2459 36.3774H86.104V39.5193H89.2459V36.3774Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5256 36.3774H92.3838V39.5193H95.5256V36.3774Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.793 36.377H98.6514V39.5188H101.793V36.377Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.936 36.3774H101.794V39.5193H104.936V36.3774Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0334 39.5063H13.8916V42.6482H17.0334V39.5063Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4465 39.5059H23.3047V42.6477H26.4465V39.5059Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5876 39.5059H26.4458V42.6477H29.5876V39.5059Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7244 39.5059H29.5825V42.6477H32.7244V39.5059Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8669 39.5059H32.7251V42.6477H35.8669V39.5059Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0081 39.5063H35.8662V42.6482H39.0081V39.5063Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.135 39.5059H38.9932V42.6477H42.135V39.5059Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5613 39.5054H48.4194V42.6472H51.5613V39.5054Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8557 39.5059H54.7139V42.6477H57.8557V39.5059Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9763 39.5063H57.8345V42.6482H60.9763V39.5063Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1204 39.5059H60.9785V42.6477H64.1204V39.5059Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2659 39.5059H64.124V42.6477H67.2659V39.5059Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5457 39.5059H70.4038V42.6477H73.5457V39.5059Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6887 39.5059H73.5469V42.6477H76.6887V39.5059Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8191 39.5059H76.6772V42.6477H79.8191V39.5059Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9622 39.5054H79.8203V42.6472H82.9622V39.5054Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2459 39.5059H86.104V42.6477H89.2459V39.5059Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3831 39.5063H89.2412V42.6482H92.3831V39.5063Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6584 39.5059H95.5166V42.6477H98.6584V39.5059Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.079 39.5059H104.938V42.6477H108.079V39.5059Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.492 39.5059H114.35V42.6477H117.492V39.5059Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.784 39.5059H120.643V42.6477H123.784V39.5059Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.921 39.5059H123.779V42.6477H126.921V39.5059Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.066 39.5059H126.924V42.6477H130.066V39.5059Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0334 42.6484H13.8916V45.7903H17.0334V42.6484Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7244 42.6489H29.5825V45.7908H32.7244V42.6489Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0081 42.6489H35.8662V45.7908H39.0081V42.6489Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.135 42.6479H38.9932V45.7898H42.135V42.6479Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8547 42.6489H54.7129V45.7908H57.8547V42.6489Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4045 42.6479H67.2627V45.7898H70.4045V42.6479Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8191 42.6479H76.6772V45.7898H79.8191V42.6479Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9622 42.647H79.8203V45.7888H82.9622V42.647Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0994 42.6475H82.9575V45.7893H86.0994V42.6475Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5256 42.6489H92.3838V45.7908H95.5256V42.6489Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6584 42.6479H95.5166V45.7898H98.6584V42.6479Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.793 42.6484H98.6514V45.7903H101.793V42.6484Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.355 42.6494H111.213V45.7913H114.355V42.6494Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.492 42.6484H114.35V45.7903H117.492V42.6484Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.921 42.6484H123.779V45.7903H126.921V42.6484Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0334 45.79H13.8916V48.9319H17.0334V45.79Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4465 45.79H23.3047V48.9319H26.4465V45.79Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5872 45.79H26.4453V48.9319H29.5872V45.79Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8669 45.7886H32.7251V48.9304H35.8669V45.7886Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0081 45.79H35.8662V48.9319H39.0081V45.79Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2815 45.7886H42.1396V48.9304H45.2815V45.7886Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7063 45.79H51.5645V48.9319H54.7063V45.79Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9758 45.7886H57.834V48.9304H60.9758V45.7886Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4055 45.7891H67.2637V48.9309H70.4055V45.7891Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0994 45.79H82.9575V48.9319H86.0994V45.79Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3831 45.7886H89.2412V48.9304H92.3831V45.7886Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5256 45.79H92.3838V48.9319H95.5256V45.79Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.793 45.79H98.6514V48.9319H101.793V45.79Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.936 45.7886H101.794V48.9304H104.936V45.7886Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.355 45.79H111.213V48.9319H114.355V45.79Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.784 45.7896H120.643V48.9314H123.784V45.7896Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.066 45.7886H126.924V48.9304H130.066V45.7886Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3157 48.9336H20.1738V52.0754H23.3157V48.9336Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4465 48.9326H23.3047V52.0745H26.4465V48.9326Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5876 48.9326H26.4458V52.0745H29.5876V48.9326Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2815 48.9326H42.1396V52.0745H45.2815V48.9326Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4241 48.9316H45.2822V52.0735H48.4241V48.9316Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5613 48.9321H48.4194V52.074H51.5613V48.9321Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7063 48.9326H51.5645V52.0745H54.7063V48.9326Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1204 48.9326H60.9785V52.0745H64.1204V48.9326Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4045 48.9326H67.2627V52.0745H70.4045V48.9326Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5457 48.9326H70.4038V52.0745H73.5457V48.9326Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0994 48.9321H82.9575V52.074H86.0994V48.9321Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6584 48.9326H95.5166V52.0745H98.6584V48.9326Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.793 48.9321H98.6514V52.074H101.793V48.9321Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.226 48.9321H108.084V52.074H111.226V48.9321Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.639 48.9321H117.497V52.074H120.639V48.9321Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.784 48.9321H120.643V52.074H123.784V48.9321Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.921 48.9321H123.779V52.074H126.921V48.9321Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.066 48.9326H126.924V52.0745H130.066V48.9326Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1707 52.0728H17.0288V55.2146H20.1707V52.0728Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7244 52.0728H29.5825V55.2146H32.7244V52.0728Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8669 52.0728H32.7251V55.2146H35.8669V52.0728Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4221 52.0732H45.2803V55.2151H48.4221V52.0732Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7063 52.0728H51.5645V55.2146H54.7063V52.0728Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5457 52.0728H70.4038V55.2146H73.5457V52.0728Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6887 52.0728H73.5469V55.2146H76.6887V52.0728Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3831 52.0728H89.2412V55.2146H92.3831V52.0728Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.936 52.0728H101.794V55.2146H104.936V52.0728Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.079 52.0728H104.938V55.2146H108.079V52.0728Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.226 52.0737H108.084V55.2156H111.226V52.0737Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.355 52.0732H111.213V55.2151H114.355V52.0732Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.639 52.0737H117.497V55.2156H120.639V52.0737Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.066 52.0728H126.924V55.2146H130.066V52.0728Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0334 55.2148H13.8916V58.3567H17.0334V55.2148Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3157 55.2153H20.1738V58.3572H23.3157V55.2153Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4465 55.2158H23.3047V58.3577H26.4465V55.2158Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0081 55.2163H35.8662V58.3581H39.0081V55.2163Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7063 55.2158H51.5645V58.3577H54.7063V55.2158Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9763 55.2158H57.8345V58.3577H60.9763V55.2158Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1204 55.2158H60.9785V58.3577H64.1204V55.2158Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2654 55.2163H64.1235V58.3581H67.2654V55.2163Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4045 55.2168H67.2627V58.3586H70.4045V55.2168Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2459 55.2153H86.104V58.3572H89.2459V55.2153Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6584 55.2158H95.5166V58.3577H98.6584V55.2158Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.793 55.2158H98.6514V58.3577H101.793V55.2158Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.492 55.2148H114.35V58.3567H117.492V55.2148Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.639 55.2148H117.497V58.3567H120.639V55.2148Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4465 58.3452H23.3047V61.4871H26.4465V58.3452Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5876 58.3457H26.4458V61.4875H29.5876V58.3457Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8669 58.3452H32.7251V61.4871H35.8669V58.3452Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0081 58.3457H35.8662V61.4875H39.0081V58.3457Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.135 58.3452H38.9932V61.4871H42.135V58.3452Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2815 58.3442H42.1396V61.4861H45.2815V58.3442Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4241 58.3447H45.2822V61.4866H48.4241V58.3447Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5613 58.3452H48.4194V61.4871H51.5613V58.3452Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1209 58.3452H60.979V61.4871H64.1209V58.3452Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4045 58.3457H67.2627V61.4875H70.4045V58.3457Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6887 58.3442H73.5469V61.4861H76.6887V58.3442Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9622 58.3452H79.8203V61.4871H82.9622V58.3452Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0994 58.3442H82.9575V61.4861H86.0994V58.3442Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3831 58.3457H89.2412V61.4875H92.3831V58.3457Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6584 58.3442H95.5166V61.4861H98.6584V58.3442Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.793 58.3457H98.6514V61.4875H101.793V58.3457Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.079 58.3452H104.938V61.4871H108.079V58.3452Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.492 58.3452H114.35V61.4871H117.492V58.3452Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.639 58.3452H117.497V61.4871H120.639V58.3452Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.783 58.3457H120.642V61.4875H123.783V58.3457Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.921 58.3452H123.779V61.4871H126.921V58.3452Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.066 58.3442H126.924V61.4861H130.066V58.3442Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3157 61.4868H20.1738V64.6287H23.3157V61.4868Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5876 61.4858H26.4458V64.6277H29.5876V61.4858Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7244 61.4863H29.5825V64.6282H32.7244V61.4863Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.135 61.4863H38.9932V64.6282H42.135V61.4863Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4226 61.4873H45.2808V64.6291H48.4226V61.4873Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7063 61.4858H51.5645V64.6277H54.7063V61.4858Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9763 61.4858H57.8345V64.6277H60.9763V61.4858Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4055 61.4858H67.2637V64.6277H70.4055V61.4858Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5457 61.4863H70.4038V64.6282H73.5457V61.4863Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8191 61.4863H76.6772V64.6282H79.8191V61.4863Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6584 61.4868H95.5166V64.6287H98.6584V61.4868Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.793 61.4858H98.6514V64.6277H101.793V61.4858Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.936 61.4863H101.794V64.6282H104.936V61.4863Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.079 61.4863H104.938V64.6282H108.079V61.4863Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.357 61.4868H111.215V64.6287H114.357V61.4868Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.639 61.4873H117.497V64.6291H120.639V61.4873Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.784 61.4858H120.643V64.6277H123.784V61.4858Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.066 61.4868H126.924V64.6287H130.066V61.4868Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1707 64.6284H17.0288V67.7703H20.1707V64.6284Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3137 64.6284H20.1719V67.7703H23.3137V64.6284Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7244 64.6284H29.5825V67.7703H32.7244V64.6284Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8669 64.6284H32.7251V67.7703H35.8669V64.6284Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0081 64.6284H35.8662V67.7703H39.0081V64.6284Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.135 64.6284H38.9932V67.7703H42.135V64.6284Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4241 64.6284H45.2822V67.7703H48.4241V64.6284Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7063 64.6284H51.5645V67.7703H54.7063V64.6284Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1204 64.6284H60.9785V67.7703H64.1204V64.6284Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2654 64.6289H64.1235V67.7707H67.2654V64.6289Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4045 64.6284H67.2627V67.7703H70.4045V64.6284Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6887 64.6284H73.5469V67.7703H76.6887V64.6284Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8191 64.6284H76.6772V67.7703H79.8191V64.6284Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9622 64.6284H79.8203V67.7703H82.9622V64.6284Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2459 64.6284H86.104V67.7703H89.2459V64.6284Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5256 64.6284H92.3838V67.7703H95.5256V64.6284Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.793 64.6279H98.6514V67.7698H101.793V64.6279Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.226 64.6284H108.084V67.7703H111.226V64.6284Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.784 64.6284H120.643V67.7703H123.784V64.6284Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.921 64.6289H123.779V67.7707H126.921V64.6289Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0334 67.772H13.8916V70.9138H17.0334V67.772Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3157 67.7705H20.1738V70.9123H23.3157V67.7705Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.135 67.7705H38.9932V70.9123H42.135V67.7705Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2815 67.7705H42.1396V70.9123H45.2815V67.7705Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4221 67.77H45.2803V70.9119H48.4221V67.77Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5613 67.7705H48.4194V70.9123H51.5613V67.7705Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8547 67.772H54.7129V70.9138H57.8547V67.772Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9763 67.7705H57.8345V70.9123H60.9763V67.7705Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2654 67.77H64.1235V70.9119H67.2654V67.77Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5457 67.7725H70.4038V70.9143H73.5457V67.7725Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8191 67.7705H76.6772V70.9123H79.8191V67.7705Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9622 67.77H79.8203V70.9119H82.9622V67.77Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2459 67.7705H86.104V70.9123H89.2459V67.7705Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3831 67.7725H89.2412V70.9143H92.3831V67.7725Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5256 67.7729H92.3838V70.9148H95.5256V67.7729Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.793 67.7705H98.6514V70.9123H101.793V67.7705Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.355 67.772H111.213V70.9138H114.355V67.772Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0334 70.9126H13.8916V74.0544H17.0334V70.9126Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8669 70.9121H32.7251V74.0539H35.8669V70.9121Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2815 70.9121H42.1396V74.0539H45.2815V70.9121Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4241 70.9121H45.2822V74.0539H48.4241V70.9121Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8552 70.9121H54.7134V74.0539H57.8552V70.9121Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1204 70.9126H60.9785V74.0544H64.1204V70.9126Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8191 70.9126H76.6772V74.0544H79.8191V70.9126Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9622 70.9131H79.8203V74.0549H82.9622V70.9131Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2459 70.9121H86.104V74.0539H89.2459V70.9121Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5256 70.9126H92.3838V74.0544H95.5256V70.9126Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.793 70.9126H98.6514V74.0544H101.793V70.9126Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.639 70.9126H117.497V74.0544H120.639V70.9126Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.066 70.9121H126.924V74.0539H130.066V70.9121Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0334 74.0547H13.8916V77.1965H17.0334V74.0547Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5876 74.0552H26.4458V77.197H29.5876V74.0552Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7244 74.0557H29.5825V77.1975H32.7244V74.0557Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.135 74.0552H38.9932V77.197H42.135V74.0552Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2815 74.0552H42.1396V77.197H45.2815V74.0552Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7063 74.0557H51.5645V77.1975H54.7063V74.0557Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3831 74.0557H89.2412V77.1975H92.3831V74.0557Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5256 74.0557H92.3838V77.1975H95.5256V74.0557Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.936 74.0552H101.794V77.197H104.936V74.0552Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.357 74.0552H111.215V77.197H114.357V74.0552Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.492 74.0552H114.35V77.197H117.492V74.0552Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.639 74.0547H117.497V77.1965H120.639V74.0547Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.066 74.0552H126.924V77.197H130.066V74.0552Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0334 77.1841H13.8916V80.3259H17.0334V77.1841Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5876 77.1836H26.4458V80.3254H29.5876V77.1836Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8669 77.1841H32.7251V80.3259H35.8669V77.1841Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0081 77.1841H35.8662V80.3259H39.0081V77.1841Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.135 77.1841H38.9932V80.3259H42.135V77.1841Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2815 77.1841H42.1396V80.3259H45.2815V77.1841Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4221 77.1841H45.2803V80.3259H48.4221V77.1841Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5613 77.1841H48.4194V80.3259H51.5613V77.1841Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7063 77.1841H51.5645V80.3259H54.7063V77.1841Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8547 77.1846H54.7129V80.3264H57.8547V77.1846Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1204 77.1841H60.9785V80.3259H64.1204V77.1841Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2654 77.1846H64.1235V80.3264H67.2654V77.1846Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4045 77.1841H67.2627V80.3259H70.4045V77.1841Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3831 77.1836H89.2412V80.3254H92.3831V77.1836Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.936 77.1841H101.794V80.3259H104.936V77.1841Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.079 77.1846H104.938V80.3264H108.079V77.1846Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.226 77.1841H108.084V80.3259H111.226V77.1841Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.355 77.1836H111.213V80.3254H114.355V77.1836Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.492 77.1846H114.35V80.3264H117.492V77.1846Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.639 77.1841H117.497V80.3259H120.639V77.1841Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1707 80.3257H17.0288V83.4675H20.1707V80.3257Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7244 80.3257H29.5825V83.4675H32.7244V80.3257Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.135 80.3257H38.9932V83.4675H42.135V80.3257Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2815 80.3257H42.1396V83.4675H45.2815V80.3257Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5613 80.3257H48.4194V83.4675H51.5613V80.3257Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8547 80.3252H54.7129V83.467H57.8547V80.3252Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9763 80.3252H57.8345V83.467H60.9763V80.3252Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1204 80.3252H60.9785V83.467H64.1204V80.3252Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6887 80.3257H73.5469V83.4675H76.6887V80.3257Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9622 80.3262H79.8203V83.468H82.9622V80.3262Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0994 80.3257H82.9575V83.4675H86.0994V80.3257Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2459 80.3257H86.104V83.4675H89.2459V80.3257Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5256 80.3257H92.3838V83.4675H95.5256V80.3257Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6584 80.3257H95.5166V83.4675H98.6584V80.3257Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.793 80.3252H98.6514V83.467H101.793V80.3252Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.492 80.3257H114.35V83.4675H117.492V80.3257Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.784 80.3252H120.643V83.467H123.784V80.3252Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0334 83.4683H13.8916V86.6101H17.0334V83.4683Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1707 83.4678H17.0288V86.6096H20.1707V83.4678Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4465 83.4683H23.3047V86.6101H26.4465V83.4683Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8669 83.4678H32.7251V86.6096H35.8669V83.4678Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0081 83.4683H35.8662V86.6101H39.0081V83.4683Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.135 83.4683H38.9932V86.6101H42.135V83.4683Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4221 83.4683H45.2803V86.6101H48.4221V83.4683Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7063 83.4683H51.5645V86.6101H54.7063V83.4683Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8552 83.4678H54.7134V86.6096H57.8552V83.4678Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1204 83.4678H60.9785V86.6096H64.1204V83.4678Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2659 83.4683H64.124V86.6101H67.2659V83.4683Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4055 83.4678H67.2637V86.6096H70.4055V83.4678Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5457 83.4678H70.4038V86.6096H73.5457V83.4678Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8191 83.4683H76.6772V86.6101H79.8191V83.4683Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0994 83.4678H82.9575V86.6096H86.0994V83.4678Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2459 83.4678H86.104V86.6096H89.2459V83.4678Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6584 83.4678H95.5166V86.6096H98.6584V83.4678Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.793 83.4683H98.6514V86.6101H101.793V83.4683Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.226 83.4678H108.084V86.6096H111.226V83.4678Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.355 83.4678H111.213V86.6096H114.355V83.4678Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.639 83.4678H117.497V86.6096H120.639V83.4678Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.066 83.4678H126.924V86.6096H130.066V83.4678Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0334 86.6089H13.8916V89.7507H17.0334V86.6089Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1707 86.6089H17.0288V89.7507H20.1707V86.6089Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5876 86.6094H26.4458V89.7512H29.5876V86.6094Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2815 86.6094H42.1396V89.7512H45.2815V86.6094Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1204 86.6094H60.9785V89.7512H64.1204V86.6094Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4045 86.6094H67.2627V89.7512H70.4045V86.6094Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6887 86.6089H73.5469V89.7507H76.6887V86.6089Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8191 86.6094H76.6772V89.7512H79.8191V86.6094Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9622 86.6094H79.8203V89.7512H82.9622V86.6094Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0994 86.6094H82.9575V89.7512H86.0994V86.6094Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6584 86.6094H95.5166V89.7512H98.6584V86.6094Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.793 86.6094H98.6514V89.7512H101.793V86.6094Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.936 86.6094H101.794V89.7512H104.936V86.6094Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.226 86.6089H108.084V89.7507H111.226V86.6089Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.355 86.6084H111.213V89.7502H114.355V86.6084Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.492 86.6089H114.35V89.7507H117.492V86.6089Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.639 86.6094H117.497V89.7512H120.639V86.6094Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.784 86.6089H120.643V89.7507H123.784V86.6089Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.066 86.6094H126.924V89.7512H130.066V86.6094Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0334 89.752H13.8916V92.8938H17.0334V89.752Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3137 89.751H20.1719V92.8928H23.3137V89.751Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4465 89.751H23.3047V92.8928H26.4465V89.751Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5876 89.752H26.4458V92.8938H29.5876V89.752Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7244 89.751H29.5825V92.8928H32.7244V89.751Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8669 89.751H32.7251V92.8928H35.8669V89.751Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5613 89.751H48.4194V92.8928H51.5613V89.751Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1209 89.751H60.979V92.8928H64.1209V89.751Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2654 89.7515H64.1235V92.8933H67.2654V89.7515Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4045 89.752H67.2627V92.8938H70.4045V89.752Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5457 89.751H70.4038V92.8928H73.5457V89.751Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9622 89.752H79.8203V92.8938H82.9622V89.752Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3831 89.7515H89.2412V92.8933H92.3831V89.7515Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.936 89.751H101.794V92.8928H104.936V89.751Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.226 89.751H108.084V92.8928H111.226V89.751Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.355 89.7515H111.213V92.8933H114.355V89.7515Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0334 92.8926H13.8916V96.0344H17.0334V92.8926Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1707 92.8921H17.0288V96.0339H20.1707V92.8921Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3137 92.8926H20.1719V96.0344H23.3137V92.8926Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5876 92.8926H26.4458V96.0344H29.5876V92.8926Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0081 92.8921H35.8662V96.0339H39.0081V92.8921Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4241 92.8926H45.2822V96.0344H48.4241V92.8926Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7063 92.8921H51.5645V96.0339H54.7063V92.8921Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8547 92.8911H54.7129V96.033H57.8547V92.8911Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9763 92.8931H57.8345V96.0349H60.9763V92.8931Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2659 92.8921H64.124V96.0339H67.2659V92.8921Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6887 92.8921H73.5469V96.0339H76.6887V92.8921Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8191 92.8926H76.6772V96.0344H79.8191V92.8926Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9622 92.8921H79.8203V96.0339H82.9622V92.8921Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6584 92.8926H95.5166V96.0344H98.6584V92.8926Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.793 92.8931H98.6514V96.0349H101.793V92.8931Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.492 92.8926H114.35V96.0344H117.492V92.8926Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0334 96.0234H13.8916V99.1653H17.0334V96.0234Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1707 96.0225H17.0288V99.1643H20.1707V96.0225Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4465 96.0225H23.3047V99.1643H26.4465V96.0225Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8669 96.0225H32.7251V99.1643H35.8669V96.0225Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0081 96.0229H35.8662V99.1648H39.0081V96.0229Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2815 96.0225H42.1396V99.1643H45.2815V96.0225Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4221 96.0229H45.2803V99.1648H48.4221V96.0229Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7063 96.0234H51.5645V99.1653H54.7063V96.0234Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8547 96.022H54.7129V99.1638H57.8547V96.022Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2659 96.0225H64.124V99.1643H67.2659V96.0225Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6887 96.0225H73.5469V99.1643H76.6887V96.0225Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8191 96.0225H76.6772V99.1643H79.8191V96.0225Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2459 96.0225H86.104V99.1643H89.2459V96.0225Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3831 96.022H89.2412V99.1638H92.3831V96.022Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6584 96.0225H95.5166V99.1643H98.6584V96.0225Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.793 96.022H98.6514V99.1638H101.793V96.022Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.936 96.0225H101.794V99.1643H104.936V96.0225Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.921 96.0225H123.779V99.1643H126.921V96.0225Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.066 96.0225H126.924V99.1643H130.066V96.0225Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0334 99.1636H13.8916V102.305H17.0334V99.1636Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3157 99.1646H20.1738V102.306H23.3157V99.1646Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4465 99.1646H23.3047V102.306H26.4465V99.1646Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5876 99.1641H26.4458V102.306H29.5876V99.1641Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7244 99.1646H29.5825V102.306H32.7244V99.1646Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0081 99.1646H35.8662V102.306H39.0081V99.1646Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.135 99.1646H38.9932V102.306H42.135V99.1646Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2815 99.1646H42.1396V102.306H45.2815V99.1646Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5613 99.1636H48.4194V102.305H51.5613V99.1636Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7063 99.1646H51.5645V102.306H54.7063V99.1646Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8547 99.165H54.7129V102.307H57.8547V99.165Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9763 99.1646H57.8345V102.306H60.9763V99.1646Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1204 99.1646H60.9785V102.306H64.1204V99.1646Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5457 99.1646H70.4038V102.306H73.5457V99.1646Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8191 99.1646H76.6772V102.306H79.8191V99.1646Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2459 99.1646H86.104V102.306H89.2459V99.1646Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.226 99.1631H108.084V102.305H111.226V99.1631Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.492 99.1636H114.35V102.305H117.492V99.1636Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.784 99.1641H120.643V102.306H123.784V99.1641Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.921 99.165H123.779V102.307H126.921V99.165Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0334 102.307H13.8916V105.448H17.0334V102.307Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3137 102.305H20.1719V105.447H23.3137V102.305Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5876 102.306H26.4458V105.448H29.5876V102.306Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8669 102.306H32.7251V105.448H35.8669V102.306Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2815 102.305H42.1396V105.447H45.2815V102.305Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7063 102.306H51.5645V105.448H54.7063V102.306Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8547 102.306H54.7129V105.448H57.8547V102.306Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8191 102.305H76.6772V105.447H79.8191V102.305Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0994 102.306H82.9575V105.448H86.0994V102.306Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3831 102.306H89.2412V105.448H92.3831V102.306Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5256 102.306H92.3838V105.448H95.5256V102.306Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.793 102.305H98.6514V105.447H101.793V102.305Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.936 102.305H101.794V105.447H104.936V102.305Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.079 102.306H104.938V105.448H108.079V102.306Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.226 102.306H108.084V105.448H111.226V102.306Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.355 102.306H111.213V105.448H114.355V102.306Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.492 102.307H114.35V105.448H117.492V102.307Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.639 102.306H117.497V105.448H120.639V102.306Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.784 102.305H120.643V105.447H123.784V102.305Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.135 105.448H38.9932V108.59H42.135V105.448Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4241 105.448H45.2822V108.59H48.4241V105.448Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5613 105.448H48.4194V108.59H51.5613V105.448Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8547 105.448H54.7129V108.59H57.8547V105.448Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9763 105.449H57.8345V108.591H60.9763V105.449Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1204 105.449H60.9785V108.591H64.1204V105.449Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5457 105.448H70.4038V108.59H73.5457V105.448Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6887 105.448H73.5469V108.59H76.6887V105.448Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0994 105.448H82.9575V108.59H86.0994V105.448Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3831 105.449H89.2412V108.591H92.3831V105.449Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5256 105.448H92.3838V108.59H95.5256V105.448Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.936 105.448H101.794V108.59H104.936V105.448Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.492 105.447H114.35V108.589H117.492V105.447Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.784 105.449H120.643V108.591H123.784V105.449Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.135 108.589H38.9932V111.731H42.135V108.589Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5613 108.59H48.4194V111.732H51.5613V108.59Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7063 108.59H51.5645V111.732H54.7063V108.59Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9763 108.59H57.8345V111.732H60.9763V108.59Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1204 108.589H60.9785V111.731H64.1204V108.589Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2659 108.589H64.124V111.731H67.2659V108.589Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6887 108.589H73.5469V111.731H76.6887V108.589Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8191 108.589H76.6772V111.731H79.8191V108.589Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9622 108.59H79.8203V111.732H82.9622V108.59Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0994 108.589H82.9575V111.731H86.0994V108.589Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2459 108.589H86.104V111.731H89.2459V108.589Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3831 108.59H89.2412V111.732H92.3831V108.59Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.936 108.589H101.794V111.731H104.936V108.589Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.226 108.59H108.084V111.732H111.226V108.59Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.492 108.59H114.35V111.732H117.492V108.59Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.921 108.589H123.779V111.731H126.921V108.589Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.066 108.589H126.924V111.731H130.066V108.589Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.135 111.719H38.9932V114.861H42.135V111.719Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2815 111.72H42.1396V114.862H45.2815V111.72Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4221 111.719H45.2803V114.861H48.4221V111.719Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7063 111.719H51.5645V114.861H54.7063V111.719Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8547 111.719H54.7129V114.861H57.8547V111.719Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9763 111.719H57.8345V114.861H60.9763V111.719Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1209 111.719H60.979V114.861H64.1209V111.719Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4045 111.719H67.2627V114.861H70.4045V111.719Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5457 111.72H70.4038V114.862H73.5457V111.72Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6887 111.72H73.5469V114.862H76.6887V111.72Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0994 111.72H82.9575V114.862H86.0994V111.72Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2459 111.72H86.104V114.862H89.2459V111.72Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5256 111.719H92.3838V114.861H95.5256V111.719Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6584 111.72H95.5166V114.862H98.6584V111.72Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.793 111.719H98.6514V114.861H101.793V111.719Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.936 111.719H101.794V114.861H104.936V111.719Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.492 111.72H114.35V114.862H117.492V111.72Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.066 111.72H126.924V114.862H130.066V111.72Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.135 114.861H38.9932V118.003H42.135V114.861Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2815 114.861H42.1396V118.003H45.2815V114.861Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8547 114.86H54.7129V118.002H57.8547V114.86Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9763 114.861H57.8345V118.003H60.9763V114.861Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1204 114.861H60.9785V118.003H64.1204V114.861Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6887 114.861H73.5469V118.003H76.6887V114.861Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9622 114.86H79.8203V118.002H82.9622V114.86Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0994 114.861H82.9575V118.003H86.0994V114.861Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2459 114.861H86.104V118.003H89.2459V114.861Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3831 114.861H89.2412V118.003H92.3831V114.861Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6584 114.861H95.5166V118.003H98.6584V114.861Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.793 114.861H98.6514V118.003H101.793V114.861Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.936 114.861H101.794V118.003H104.936V114.861Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.079 114.861H104.938V118.003H108.079V114.861Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.226 114.86H108.084V118.002H111.226V114.86Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.355 114.861H111.213V118.003H114.355V114.861Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.492 114.861H114.35V118.003H117.492V114.861Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.921 114.861H123.779V118.003H126.921V114.861Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.066 114.861H126.924V118.003H130.066V114.861Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.135 118.004H38.9932V121.146H42.135V118.004Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4221 118.003H45.2803V121.145H48.4221V118.003Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7063 118.004H51.5645V121.146H54.7063V118.004Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8547 118.003H54.7129V121.145H57.8547V118.003Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9763 118.004H57.8345V121.146H60.9763V118.004Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2654 118.003H64.1235V121.145H67.2654V118.003Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5457 118.004H70.4038V121.146H73.5457V118.004Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3831 118.004H89.2412V121.146H92.3831V118.004Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6584 118.004H95.5166V121.146H98.6584V118.004Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.793 118.004H98.6514V121.146H101.793V118.004Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.079 118.004H104.938V121.146H108.079V118.004Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.226 118.004H108.084V121.146H111.226V118.004Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.639 118.004H117.497V121.146H120.639V118.004Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.921 118.003H123.779V121.145H126.921V118.003Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2815 121.145H42.1396V124.286H45.2815V121.145Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5613 121.145H48.4194V124.287H51.5613V121.145Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8552 121.144H54.7134V124.286H57.8552V121.144Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1204 121.145H60.9785V124.287H64.1204V121.145Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2659 121.145H64.124V124.287H67.2659V121.145Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4055 121.144H67.2637V124.286H70.4055V121.144Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5457 121.144H70.4038V124.286H73.5457V121.144Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6887 121.144H73.5469V124.286H76.6887V121.144Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8191 121.145H76.6772V124.287H79.8191V121.145Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9622 121.145H79.8203V124.287H82.9622V121.145Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2459 121.145H86.104V124.286H89.2459V121.145Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.793 121.146H98.6514V124.287H101.793V121.146Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.936 121.145H101.794V124.286H104.936V121.145Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.079 121.145H104.938V124.287H108.079V121.145Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.492 121.145H114.35V124.286H117.492V121.145Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.921 121.145H123.779V124.287H126.921V121.145Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.066 121.145H126.924V124.286H130.066V121.145Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2815 124.287H42.1396V127.428H45.2815V124.287Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4221 124.287H45.2803V127.429H48.4221V124.287Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7063 124.287H51.5645V127.428H54.7063V124.287Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8547 124.287H54.7129V127.428H57.8547V124.287Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9763 124.286H57.8345V127.428H60.9763V124.286Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2654 124.287H64.1235V127.429H67.2654V124.287Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4055 124.286H67.2637V127.428H70.4055V124.286Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6887 124.287H73.5469V127.428H76.6887V124.287Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8191 124.287H76.6772V127.428H79.8191V124.287Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6584 124.287H95.5166V127.428H98.6584V124.287Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.793 124.287H98.6514V127.429H101.793V124.287Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.492 124.287H114.35V127.428H117.492V124.287Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.639 124.287H117.497V127.428H120.639V124.287Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.784 124.286H120.643V127.428H123.784V124.286Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.921 124.287H123.779V127.429H126.921V124.287Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.066 124.287H126.924V127.428H130.066V124.287Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.135 127.428H38.9932V130.57H42.135V127.428Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7043 127.427H51.5625V130.569H54.7043V127.427Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8547 127.427H54.7129V130.569H57.8547V127.427Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1204 127.428H60.9785V130.57H64.1204V127.428Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8191 127.428H76.6772V130.57H79.8191V127.428Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2459 127.428H86.104V130.57H89.2459V127.428Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3831 127.428H89.2412V130.57H92.3831V127.428Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.936 127.428H101.794V130.57H104.936V127.428Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.079 127.428H104.938V130.57H108.079V127.428Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.355 127.428H111.213V130.57H114.355V127.428Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.639 127.428H117.497V130.57H120.639V127.428Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.066 127.428H126.924V130.57H130.066V127.428Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5985 14.3833H17.2466H13.9692V17.6607V33.0988V36.3762H17.2466H32.5985H35.8759V33.0988V17.7469V14.4695H32.5985V14.3833ZM32.5985 33.0988H17.2466V17.7469H32.5985V33.0988Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.753 14.3823H111.401H108.124V17.6597V33.0978V36.3752H111.401H126.753H130.03V33.0978V17.7459V14.4686H126.753V14.3823ZM126.753 33.0978H111.401V17.7459H126.753V33.0978Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5985 108.626H17.2466H13.9692V111.903V127.255V130.533H17.2466H32.5985H35.8759V127.255V111.903V108.626H32.5985ZM32.5985 127.255H17.2466V111.903H32.5985V127.255Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5974 20.6807H20.1719V30.1062H29.5974V20.6807Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.776 20.6802H114.35V30.1057H123.776V20.6802Z",
    fill: "#003C84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5974 114.861H20.1719V124.286H29.5974V114.861Z",
    fill: "#003C84"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.5H136C139.314 2.5 142 5.18629 142 8.5V136.5C142 139.814 139.314 142.5 136 142.5H131.52V144.5H136C140.418 144.5 144 140.918 144 136.5V8.5C144 4.08172 140.418 0.5 136 0.5H8C3.58172 0.5 0 4.08173 0 8.5V136.5C0 140.918 3.58173 144.5 8 144.5H14.4V142.5H8C4.68629 142.5 2 139.814 2 136.5V8.5C2 5.18629 4.68629 2.5 8 2.5Z",
    fill: "#003C84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4754 147.669C20.1624 147.669 18.9401 147.149 18.0686 146.265L18.9519 145.225C19.6413 145.914 20.5776 146.356 21.5006 146.356C22.6576 146.356 23.3073 145.81 23.3068 145.004C23.3062 144.133 22.6561 143.86 21.7718 143.47L20.4455 142.898C19.5222 142.508 18.4948 141.78 18.4939 140.389C18.4929 138.881 19.8182 137.75 21.6382 137.75C22.7562 137.75 23.8095 138.218 24.538 138.959L23.7456 139.921C23.1473 139.388 22.4841 139.063 21.6391 139.063C20.6641 139.063 20.0274 139.531 20.0278 140.285C20.0283 141.117 20.7955 141.429 21.5757 141.741L22.8891 142.3C24.0204 142.781 24.8398 143.483 24.8407 144.887C24.8417 146.421 23.5684 147.669 21.4754 147.669ZM29.4366 147.669C27.4996 147.669 26.0168 146.304 26.0153 143.925C26.0138 141.546 27.6639 140.168 29.5489 140.168C30.4589 140.168 31.1222 140.532 31.6424 140.987L30.9021 141.962C30.5118 141.611 30.1087 141.403 29.6277 141.403C28.4187 141.403 27.5613 142.417 27.5623 143.925C27.5632 145.446 28.3959 146.447 29.5789 146.447C30.1769 146.447 30.7097 146.161 31.1385 145.797L31.7631 146.785C31.1004 147.37 30.2556 147.669 29.4366 147.669ZM34.7908 147.669C33.5558 147.669 32.6843 146.863 32.6835 145.602C32.6825 144.068 33.982 143.275 36.9588 142.95C36.9453 142.118 36.6459 141.39 35.5929 141.39C34.8389 141.39 34.1371 141.728 33.5263 142.118L32.9667 141.104C33.7074 140.636 34.7081 140.168 35.8521 140.168C37.6331 140.168 38.4528 141.299 38.454 143.197L38.4567 147.5H37.2347L37.1172 146.681H37.0652C36.4155 147.24 35.6488 147.669 34.7908 147.669ZM35.2451 146.486C35.8691 146.486 36.3759 146.187 36.9605 145.654L36.9594 143.899C34.8406 144.146 34.1259 144.692 34.1264 145.498C34.1269 146.2 34.6081 146.486 35.2451 146.486ZM40.5782 147.5L40.5738 140.35H41.7958L41.9134 141.338H41.9524C42.615 140.701 43.3426 140.168 44.3176 140.168C45.8386 140.168 46.5153 141.182 46.5164 143.002L46.5192 147.5H45.0242L45.0215 143.184C45.0208 141.949 44.6564 141.455 43.8114 141.455C43.1484 141.455 42.6937 141.793 42.0701 142.43L42.0732 147.5H40.5782ZM54.0156 147.669C52.4036 147.669 51.8439 146.668 51.843 145.16L51.8407 141.546H50.8007L50.8 140.428L51.918 140.35L52.0857 138.374H53.3337L53.335 140.35H55.194L55.1947 141.546H53.3357L53.338 145.173C53.3385 146.031 53.6378 146.473 54.3788 146.473C54.6258 146.473 54.9378 146.395 55.1457 146.304L55.4194 147.409C55.0165 147.539 54.5356 147.669 54.0156 147.669ZM59.409 147.669C57.641 147.669 56.0412 146.304 56.0397 143.925C56.0382 141.546 57.6363 140.168 59.4043 140.168C61.1723 140.168 62.7722 141.546 62.7737 143.925C62.7752 146.304 61.177 147.669 59.409 147.669ZM59.4083 146.447C60.5393 146.447 61.2406 145.446 61.2397 143.925C61.2388 142.417 60.5361 141.403 59.4051 141.403C58.2871 141.403 57.5858 142.417 57.5867 143.925C57.5876 145.446 58.2903 146.447 59.4083 146.447ZM67.5842 147.5L67.5782 137.919H70.0612C72.9992 137.919 74.6772 139.557 74.6792 142.677C74.6811 145.784 73.0052 147.5 70.1452 147.5H67.5842ZM69.0914 146.265H69.9624C72.0164 146.265 73.1207 145.056 73.1192 142.677C73.1177 140.285 72.012 139.154 69.958 139.154H69.087L69.0914 146.265ZM79.4042 147.669C77.6362 147.669 76.0363 146.304 76.0348 143.925C76.0333 141.546 77.6315 140.168 79.3995 140.168C81.1675 140.168 82.7673 141.546 82.7688 143.925C82.7703 146.304 81.1722 147.669 79.4042 147.669ZM79.4034 146.447C80.5344 146.447 81.2358 145.446 81.2348 143.925C81.2339 142.417 80.5312 141.403 79.4002 141.403C78.2822 141.403 77.5809 142.417 77.5818 143.925C77.5828 145.446 78.2854 146.447 79.4034 146.447ZM85.6102 147.5L83.6688 140.35H85.1768L86.1282 144.211C86.2716 144.913 86.389 145.563 86.5194 146.252H86.5714C86.727 145.563 86.8696 144.9 87.0382 144.211L88.0498 140.35H89.4278L90.4572 144.211C90.6266 144.913 90.77 145.563 90.9394 146.252H90.9914C91.134 145.563 91.2506 144.913 91.4062 144.211L92.3268 140.35H93.7308L91.8892 147.5H90.0952L89.183 143.964C89.0136 143.288 88.8832 142.638 88.7267 141.897H88.6617C88.5192 142.638 88.3896 143.301 88.208 143.977L87.3392 147.5H85.6102ZM95.2189 147.5L95.2144 140.35H96.4364L96.554 141.338H96.593C97.2556 140.701 97.9833 140.168 98.9583 140.168C100.479 140.168 101.156 141.182 101.157 143.002L101.16 147.5H99.6649L99.6622 143.184C99.6614 141.949 99.2971 141.455 98.4521 141.455C97.7891 141.455 97.3343 141.793 96.7107 142.43L96.7139 147.5H95.2189ZM104.813 147.669C103.734 147.669 103.331 146.98 103.33 145.823L103.325 137.139H104.82L104.825 145.901C104.825 146.304 104.994 146.447 105.176 146.447C105.241 146.447 105.293 146.447 105.423 146.421L105.619 147.552C105.437 147.617 105.19 147.669 104.813 147.669ZM110.063 147.669C108.295 147.669 106.695 146.304 106.694 143.925C106.693 141.546 108.291 140.168 110.059 140.168C111.827 140.168 113.427 141.546 113.428 143.925C113.429 146.304 111.831 147.669 110.063 147.669ZM110.063 146.447C111.194 146.447 111.895 145.446 111.894 143.925C111.893 142.417 111.19 141.403 110.059 141.403C108.941 141.403 108.24 142.417 108.241 143.925C108.242 145.446 108.945 146.447 110.063 146.447ZM116.688 147.669C115.453 147.669 114.582 146.863 114.581 145.602C114.58 144.068 115.88 143.275 118.856 142.95C118.843 142.118 118.543 141.39 117.49 141.39C116.736 141.39 116.035 141.728 115.424 142.118L114.864 141.104C115.605 140.636 116.606 140.168 117.75 140.168C119.531 140.168 120.35 141.299 120.351 143.197L120.354 147.5H119.132L119.015 146.681H118.963C118.313 147.24 117.546 147.669 116.688 147.669ZM117.143 146.486C117.767 146.486 118.273 146.187 118.858 145.654L118.857 143.899C116.738 144.146 116.023 144.692 116.024 145.498C116.024 146.2 116.506 146.486 117.143 146.486ZM124.946 147.669C123.152 147.669 121.994 146.304 121.992 143.925C121.991 141.611 123.459 140.168 125.058 140.168C125.877 140.168 126.397 140.48 126.983 140.974L126.917 139.791L126.915 137.139H128.41L128.417 147.5H127.195L127.077 146.694H127.025C126.493 147.24 125.752 147.669 124.946 147.669ZM125.296 146.434C125.894 146.434 126.401 146.161 126.92 145.563L126.918 142.066C126.385 141.585 125.878 141.416 125.345 141.416C124.344 141.416 123.538 142.365 123.539 143.912C123.54 145.537 124.178 146.434 125.296 146.434Z",
    fill: "#003C84"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3052_13818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    transform: "translate(12 12.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountOpeningQrcode1);
export default __webpack_public_path__ + "static/media/account_opening_qrcode_1.4cf13433cf61c6cee93b28296496b4bb.svg";
export { ForwardRef as ReactComponent };